import { from } from 'rxjs';
import { filter } from 'rxjs/operators';
import { SOURCE_ROLE_HOST } from '@studio/constants/Sources';
import { CAMERA_PRESENTER } from '@studio/constants/Sources';
import { VENDOR_CHIME } from '@studio/constants/Vendor';
import setAttendeeName from '@shoflo/studio-redux/actions/attendee/setAttendeeName';
import setAudioInputDevice from '@shoflo/studio-redux/actions/meeting/setAudioInputDevice';
import setAudioOutputDevice from '@shoflo/studio-redux/actions/meeting/setAudioOutputDevice';
import setVideoInputDevice from '@shoflo/studio-redux/actions/meeting/setVideoInputDevice';
import startProgram from '@shoflo/studio-redux/actions/program/startProgram';
import createOrUpdateSource from '@shoflo/studio-redux/actions/source/createOrUpdateSource';
import {
  NO_DEVICE_FOUND,
  PERMISSION_DENIED
} from '@studio/constants/ReadinessCheck';
import { BROADCAST_CREATE_MEETING } from '@shoflo/studio-redux/actions/meeting/types';
import { shouldHaveFeature } from '@studio/feature.flags/featureFlags';

/**
 * Create a meeting for the host after they click the Join button
 * Join the meeting
 *
 * @param store
 */
export const joinMeeting = store => next => async action => {
  const { dispatch, getState } = store;

  const targetdActions = [`${BROADCAST_CREATE_MEETING}_SUCCESS`];

  from([action])
    .pipe(filter($action => targetdActions.includes($action.type)))
    .subscribe(async $action => {
      const meetingType = shouldHaveFeature('studio.meetingVendor');
      const isChimeMeeting = [VENDOR_CHIME, null, false, '', 'false'].includes(
        meetingType
      );
      const {
        user,
        broadcastSources,
        readinessCheck: { camera }
      } = getState();
      if (!$action.payload.settings || !isChimeMeeting) return;
      const {
        audioInputDeviceId,
        audioOutputDeviceId,
        presenterTitle,
        presenterDescription,
        videoInput
      } = $action.payload.settings;

      const { sources } = broadcastSources;

      const { attendeeResponse, meetingResponse, meetingSession } =
        $action.payload;
      const { AttendeeId: attendeeId } = attendeeResponse.Attendee;

      dispatch(
        setAttendeeName(attendeeId, presenterTitle, '', SOURCE_ROLE_HOST)
      );

      // this change is required to update the attendee roster when more than one hosts joins the session, new host don't have details of older presenters.
      sources.forEach(source => {
        if (source.type === 'cameraPresenter') {
          dispatch(
            setAttendeeName(
              source.value,
              source.title,
              source?.photo,
              source?.role
            )
          );
        }
      });
      const cameraUnavailable =
        camera === NO_DEVICE_FOUND || camera === PERMISSION_DENIED;

      const sourcePayload = {
        title: presenterTitle,
        type: CAMERA_PRESENTER,
        value: attendeeId,
        order: 1,
        description: presenterDescription,
        userId: user._id,
        role: SOURCE_ROLE_HOST,
        cameraUnavailable
      };
      dispatch(createOrUpdateSource(sourcePayload));

      const settings = {
        meeting: {
          attendeeResponse,
          meetingResponse,
          meetingSession
        }
      };

      audioInputDeviceId &&
        dispatch(setAudioInputDevice(audioInputDeviceId, settings));
      audioOutputDeviceId &&
        dispatch(setAudioOutputDevice(audioOutputDeviceId, settings));
      videoInput && dispatch(setVideoInputDevice(videoInput));

      dispatch(startProgram());
    });
  return next(action);
};

export default joinMeeting;
